import { render } from "./survey-results.component.vue?vue&type=template&id=a2f26522&ts=true"
import script from "./survey-results.component.vue?vue&type=script&lang=ts"
export * from "./survey-results.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__